export default (payment) => {
    switch (payment) {
        case 'cod':
            return 'Inbetalningskort';
        case 'payex_psp_cc':
            return 'Direktbetalning med kort';
        case 'payex_psp_swish':
            return 'Swish';
        case 'signicat_payment_gateway':
            return 'Autogiro';
        case 'mysoft_ocr_payment_gateway':
            return 'Blankett';
    }
};
